export const GET_GAMES = "GET_GAMES";
export const ON_CHANGE = "ON_CHANGE";
export const GET_BRANDS = "GET_BRANDS";
export const ON_MENU_CLICK = "ON_MENU_CLICK";
